import React, { useState, useRef } from 'react';
import { AlmeAppUtilsBase } from "../../AlmeApp/AlmeAppState";
import ConfirmDialog from '../../AlmeDialog/ConfirmDialog';
import IconButton from '../../AlmeUtilities/Icons/IconButton';
import AlmeOverlaySurveyDialog from '../../AlmeOverlayForm/OverlaySurvey/AlmeOverlaySurveyDialog';
import { getSurveyUrl } from '../../../utils/UrlUtils';
import { getAlmeSessionData } from '../../AlmeApp/AlmeAppSessionState';
import postMessage from '../../../post-message/PostMessageUtils';
import { CloseContainer } from './AlmeClose.styles';
import { TerminateLiveChat } from "../../LiveChat/AlmeLiveChatReportingEvents";
import { isRCPostLoginMobile } from '../../../platform/identifiers';
import { getCurrentHadLiveChatCookieValue } from '../../LiveChat/AlmeLiveChatSurvey/HadLiveChatQualtricsCookie';
const AlmeClose = (props) => {
    var _a;
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openSurvey, setOpenSurvey] = useState(false);
    const surveyUrl = props.almeAppConfig["IvaOnly.SurveyUrl"];
    const finalSurveyUrl = getSurveyUrl(props.almeAppConfig, false, surveyUrl, props.isLoggedIn, props.chatId, (_a = getAlmeSessionData()) === null || _a === void 0 ? void 0 : _a.sessionId);
    const returnFocusToElement = useRef(null);
    const handleSurveyClose = () => {
        setOpenSurvey(false);
        props.onCloseClick();
        props.setIsDialogOpen(false);
    };
    const handleCancelClose = () => {
        setTimeout(() => {
            var _a;
            (_a = returnFocusToElement.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 10);
        setOpenConfirmDialog(false);
        props.setIsDialogOpen(false);
    };
    const handleClose = () => {
        if ( /*props.chatId &&*/!props.isLivechatSurveyLoaded && (getCurrentHadLiveChatCookieValue() === "false" && finalSurveyUrl !== "empty" && finalSurveyUrl !== '')) {
            setOpenSurvey(true);
            setOpenConfirmDialog(false);
            props.setIsDialogOpen(false);
        }
        else {
            setOpenSurvey(false);
            setOpenConfirmDialog(false);
            props.onCloseClick();
            props.setIsDialogOpen(false);
        }
    };
    const handleClickOpen = () => {
        if (props.isSessionExpired) {
            props.onCloseClick();
        }
        else {
            returnFocusToElement.current = document.activeElement;
            setOpenConfirmDialog(true);
            props.setIsDialogOpen(true);
        }
    };
    if (!props.almeAppConfig.header.isCloseEnabled) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(CloseContainer, null,
            React.createElement(IconButton, Object.assign({ id: 'alme-close', className: 'alme--window--header--toolbar--close', "aria-label": "Close chat window", title: "Close chat window", iconType: "CloseButton", size: 20, onClick: handleClickOpen, type: "button" }, props.focusProps))),
        openConfirmDialog
            ? React.createElement(ConfirmDialog, { id: "alme-close-dialog", ariaLabelledBy: "alme-close-dialog-title", ariaDescribedBy: "alme-close-dialog-description", isOpen: openConfirmDialog, yesLabel: 'Yes', noLabel: 'No', onYes: handleClose, onNo: handleCancelClose, title: 'End Chat', description: 'Are you sure you want to end this chat?', height: 250, returnFocusToElement: returnFocusToElement.current })
            : null,
        openSurvey
            ? React.createElement(AlmeOverlaySurveyDialog, { isOpen: openSurvey, surveyURL: finalSurveyUrl, onCloseSurvey: handleSurveyClose })
            : null));
};
export default AlmeClose;
export class AlmeCloseUtils extends AlmeAppUtilsBase {
    endConversation() {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.apiUtils.endConversation();
    }
    constructor(almeState, setAlmeState, appConfig, apiUtils, clearSessionData) {
        super(almeState, setAlmeState, appConfig);
        this.apiUtils = apiUtils;
        this.clearSessionData = clearSessionData;
    }
    async onCloseClick() {
        var _a, _b, _c, _d;
        if (this.almeState.isLiveChatConnected) {
            await TerminateLiveChat(this.apiUtils, this.almeState);
        }
        this.clearSessionData();
        const _accessKey = ((_b = (_a = this.appConfig) === null || _a === void 0 ? void 0 : _a.main) === null || _b === void 0 ? void 0 : _b.platform) === "VISTA" ? undefined : this.almeState.accessKey;
        const _isLoggedin = ((_d = (_c = this.appConfig) === null || _c === void 0 ? void 0 : _c.main) === null || _d === void 0 ? void 0 : _d.platform) === "VISTA" ? true : false;
        this.setAlmeState(Object.assign(Object.assign({}, this.almeState), { isOpen: false, history: [], isLoggedIn: _isLoggedin, clientSessionId: undefined, hasPreviousConversation: false, sessionExpired: false, accessKey: _accessKey, lastActivityTime: undefined, isLiveChatConnected: false, isInitialAppEventsSent: false, interactionId: undefined, currentEnterpriseId: undefined }));
        if (this.appConfig.main.platform === "PSCC" || isRCPostLoginMobile()) {
            postMessage({
                type: 'IsClosed',
                source: 'nit',
            });
        }
        this.endConversation();
    }
}
